module.exports = __webpack_public_path__ + "static/img/case_banner_09.1278441.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_banner_09.png
// module id = OBHX
// module chunks = 34